module.exports = __webpack_public_path__ + "img/paystatus_success.68ded3d0.png";